var _style, _path, _path2, _path3, _path4, _circle, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 118",
    style: {
      enableBackground: "new 0 0 120 118"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.7,17.5c-11.2,2.5-19.8,12-20.8,23.7c-10.9-0.4-19.7-9.4-19.7-20.4c0-11.3,9.1-20.4,20.4-20.4 C43.7,0.5,52.1,7.9,53.7,17.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.8,20.9c0,10.6-8.2,19.4-18.6,20.3c-1.1-12-10.2-21.8-21.9-23.9C67,7.7,75.3,0.5,85.4,0.5 C96.6,0.5,105.8,9.6,105.8,20.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.7,83.1c0,2.1-0.1,4.1-0.4,6.1h-19.5C95.3,77.9,86.6,69.1,76,64.5c5.7-4,9.7-10.3,10.9-17.4 c0.1-0.8,0.2-1.7,0.3-2.5c0.2,0,0.4,0,0.6,0c2.4,0,4.7,0.3,7,0.9h0C109.6,49.2,120.7,64.6,120.7,83.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.6,111.3c0,2.4-0.2,4.8-0.5,7.2H21.3c-0.3-2.3-0.5-4.7-0.5-7.2c0-7.6,1.6-14.8,4.4-21.1 c4.6-10.3,12.4-18.2,21.9-22c0.8-0.3,1.8-0.3,2.6,0c2.3,1,4.8,1.7,7.4,2.1c1.1,0.1,2.1,0.2,3.2,0.2c0.1,0,0.1,0,0.2,0 c3.6,0,7-0.7,10.1-2c0.8-0.3,1.8-0.3,2.6,0c9.1,3.9,16.5,11.7,21,21.7C97,96.5,98.6,103.7,98.6,111.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 60.1,
    cy: 43.5,
    r: 21.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-0.2,83c0,2.1,0.1,4.1,0.4,6.1h19.5C25.3,77.8,34,69,44.5,64.4c-5.7-4-9.7-10.3-10.9-17.4 c-0.1-0.8-0.2-1.7-0.3-2.5c-0.2,0-0.4,0-0.6,0c-2.4,0-4.7,0.3-7,0.9h0C10.9,49.1-0.2,64.5-0.2,83z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.9bf77b5e1ec1b38ca90f4bfae09bd080.svg";
export { ForwardRef as ReactComponent };